import { render, staticRenderFns } from "./RichTextEditor.vue?vue&type=template&id=a4edcc66&scoped=true&"
import script from "./RichTextEditor.vue?vue&type=script&lang=js&"
export * from "./RichTextEditor.vue?vue&type=script&lang=js&"
import style0 from "./RichTextEditor.vue?vue&type=style&index=0&id=a4edcc66&scoped=true&lang=css&"
import style1 from "./RichTextEditor.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4edcc66",
  null
  
)

export default component.exports